/**
 * Timezone reference data (T12, frontend-only). A short, honest US-centric list
 * for the Settings Business timezone picker — the app has no full tz picker
 * elsewhere (org create just grabs the browser zone). The seller's current zone
 * is always preserved by the page even if it falls outside this list.
 */

/** Selectable timezones for the Business form. */
const TIMEZONES = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'UTC',
];

export { TIMEZONES };
